/* LMRBIcon.js */

"use strict";
const BaseIcon = require("@gluenetworks/steve_ui_core").IconTypes["base-icon-gl"];

class LMRBIcon extends BaseIcon {
    createdCallback() {
        super.createdCallback(arguments);
        this._lmrbPosition = "default";
    }

    /**
     * Array containing the names of the attributes you want to observe
     */
    static get observedAttributes() {
        return ["data-lmrb-position"];
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
        if (attrName === "data-lmrb-position") {
            this.setIconPosition(newVal);
        }
    }

    /***************************************/
    /* START ACTIVE STATE METHODS */

    /***************************************/
    setIconPosition(side) {
        let specificIconSvg = this[`_lmrb_${side}_icon`];
        if (specificIconSvg) {
            this.innerHTML = specificIconSvg;
        }
    }

    /***************************************/
    /* END ACTIVE STATES METHODS*/
    /***************************************/
}

let icon,
    customElementRegistry = window.customElements;

if (customElementRegistry) {
    customElementRegistry.define("lmrb-icon-gl", LMRBIcon);
    icon = customElementRegistry.get("lmrb-icon-gl");
} else if (document.registerElement) {
    icon = document.registerElement("lmrb-icon-gl", LMRBIcon);
} else {
    icon = LMRBIcon;
}

module.exports = icon;
